/* eslint-disable react-hooks/exhaustive-deps */
import { UploadServiceSettingsProvider } from '@davies-group/document-upload-lib';
import { ThemeProvider } from '@davies-group/white-label-ui/theme';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { SetupWorkerApi } from 'msw';

import { worker } from './__mocks__/browser';
import { useDocumentUpload } from './context/DocumentUploadContext';
import AppTheme from './AppTheme';
import { useDocumentRequestService } from './services';
import { applicationSettings } from './utils';

export default function App() {
    const [isPreparingMock, setIsPreparingMock] = useState<boolean>(true);
    const { state, dispatch } = useDocumentUpload();
    const location = useLocation();
    const documentRequestService = useDocumentRequestService();

    useEffect(() => {
        prepare();
    }, []);

    useEffect(() => {
        if (!isPreparingMock) {
            const requestId = location.pathname.replace('/', '');
            dispatch({
                type: 'updateRequestId',
                payload: requestId,
            });
            getDocument(requestId);
        }
    }, [isPreparingMock]);

    const prepare = () => {
        if (applicationSettings.environment && applicationSettings.environment === 'Mock') {
            (worker as SetupWorkerApi).start().then(() => {
                setIsPreparingMock(false);
            });
        } else {
            setIsPreparingMock(false);
        }
    };

    const getDocument = (requestId: string) => {
        documentRequestService
            .getDocumentRequest(requestId)
            .then((value) => {
                dispatch({ type: 'updateDocumentRequest', payload: value });
            })
            .catch((err) => {
                dispatch({ type: 'updateError', payload: err.message });
            });
    };

    return (
        <>
            {!isPreparingMock && (
                <ThemeProvider apiUrl={applicationSettings.brandingApiUrl} brandId={state.documentRequest.branding.brandId} clientId={state.documentRequest.branding.clientId}>
                    <UploadServiceSettingsProvider apiUploadEndpoint={`${applicationSettings.documentApiUrl}/upload`} apiDeleteEndpoint={`${applicationSettings.documentApiUrl}/delete`} uploadInstructionTextEmpty="Please select or drag and drop the file(s) you wish to upload" uploadInstructionTextPopulated="Please select or drag and drop any additional file(s) you also wish to upload" fileTooLargeText="The file is too large." unknownErrorText="Something went wrong." fileCountLimitReachedText="Maximum number of files has been reached.">
                        <AppTheme />
                    </UploadServiceSettingsProvider>
                </ThemeProvider>
            )}
        </>
    );
}
